import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background: #1a1a1a;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
`

interface Props {
  children: ReactNode
}

const Box: FC<Props> = ({ children }) => {
  return <Container>{children}</Container>
}

export default Box
